import React from "react"
import {useLocal, useMessage} from "../AppContext"
import {CopyToClipboard} from "../Helper/Clipboard"
import {iconCopyToClipboard} from "../Helper/Icons"
import style from "./Clipboard.css"

export const Clipboard = ({code}) => {
    const message = useMessage()
    const local = useLocal()

    const actionClick = () => {
        CopyToClipboard(code)
        message.showSuccess(local.__("Raumcode wurde in die Zwischenablage kopiert."))
    }

    return <div className={style.clipboard} onClick={actionClick}>{iconCopyToClipboard}</div>
}
